export default {
    ApplicationHeader: () => import("./header.vue"),
    AppsMenu: () => import("./apps-menu.vue"),
    AppHomeContent: () => import("./single-app/app-home-content.vue"),
    AppHomeHeader: () => import("./single-app/app-home-header.vue")
};
